import { Link } from "react-router-dom";
import ImageSlider from "./ImageSlider";
import { FaCode, FaExternalLinkAlt, FaYoutube } from "react-icons/fa";

export default function ProjectCard({ project }) {
  const hasLinks =
    project.codeSource || project.demoVideo || project.LiveWebsite;
  return (
    <div className="flex w-full xl:w-[min(75%,800px)] flex-col gap-7 bg-portfolio-page">
      <div className="aspect-[10/4] w-full max-w-[1200px] shrink-0 grow-0">
        <ImageSlider images={project.images} />
      </div>

      <div className="flex flex-col gap-3 px-4 py-4 [&_h3]:text-base [&_h3]:font-medium">
        <h3 className="font-medium text-portfolio-title">
          <span className="text-sm">{project.title}</span>
          <span className="text-sm">{" | "}</span>
          <span className="text-sm italic">{project.italicsTitle}</span>
        </h3>
        {hasLinks && (
          <div className="flex gap-2 [&_a]:flex [&_a]:items-center [&_a]:gap-2 [&_a]:rounded-md [&_a]:bg-portfolio-action [&_a]:px-2.5 [&_a]:py-1.5 [&_a]:text-xs [&_a]:text-portfolio-action-text [&_a]:no-underline [&_a:hover]:bg-portfolio-accent [&_a:hover]:text-portfolio-inverse [&_a_svg]:h-4 [&_a_svg]:w-4">
            {project.codeSource && (
              <Link target="_blank" to={project.codeSource}>
                <FaCode />
                <span>Source Code</span>
              </Link>
            )}
            {project.demoVideo && (
              <Link target="_blank" to={project.demoVideo}>
                <FaYoutube />
                <span>Demo Video</span>
              </Link>
            )}
            {project.LiveWebsite && (
              <Link target="_blank" to={project.LiveWebsite}>
                <FaExternalLinkAlt />
                <span>Live</span>
              </Link>
            )}
          </div>
        )}
        <div className="flex flex-col gap-4 text-sm">{project.description}</div>

        <div className="flex flex-wrap items-center gap-1">
          {project.tags.map((tag) => (
            <span
              key={tag}
              className="whitespace-nowrap rounded-md bg-portfolio-accent px-2 py-1 text-xs text-portfolio-inverse"
            >
              {tag}
            </span>
          ))}
        </div>
        {project.techSkills && (
          <div className="flex flex-wrap gap-1">
            {project.techSkills.map(({ title }) => (
              <span
                key={title}
                className="inline-flex items-center gap-2 rounded-md bg-portfolio-surface px-2.5 py-1.5 text-xs font-medium text-portfolio-text"
              >
                <span>{title}</span>
              </span>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
